import review from './review'

export default{
    review
}


// WEBPACK FOOTER //
// ./src/api/apis/business/index.js